<template>
    <div class="card mb-3 overflow-hidden">
        <div class="pb-3 radius-sm d-flex align-items-center" :class="{ 'justify-content-center' : isCenter }">
            <i class="icon me-2 fs-2" :class="[css, icon]"></i>
            <span class="b-700" :class="[css]">{{ title }}</span>
        </div>
        <slot>
            <span class="name b-500 text-default fs-4">{{ value }}</span>
        </slot>
    </div>
</template>
<script>
    import { reactive, toRefs } from 'vue';
    
    export default {
        name: "PreviewCard",
        props: { 
            css: {
                type:String,
                required: true,
            },
            icon: {
                type:String,
                required: true,
            },
            title: {
                type:String,
                required: true,
            },
            value: {
                type: String,
                default: "",
            },
            isCenter: {
                type: Boolean,
                default: false,
            }
        },
        setup(props) {
            const e = reactive({ 
            });
            return { ...toRefs(e) }
        },
    };
</script>
